module.exports = __webpack_public_path__ + "static/media/java.b60066c7.jpg";